import { ArrowLeft } from "lucide-react";
import React from "react";

import { IconButton } from "./icon-button";

interface PageHeaderProps {
  title: string;
  backHref?: string;
  icon?: React.ReactNode;
  badges?: React.ReactNode;
  actions?: React.ReactNode;
  details?: React.ReactNode;
  breadcrumb?: React.ReactNode;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  backHref,
  icon,
  badges,
  actions,
  details,
  breadcrumb,
}) => {
  return (
    <div className="space-y-3">
      {/* Breadcrumb row */}
      {breadcrumb && (
        <div className="text-sm text-muted-foreground flex items-center">
          {breadcrumb}
        </div>
      )}

      {/* Header row - responsive layout */}
      <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
        {/* Title and badges */}
        <div className="flex flex-wrap items-center gap-2 sm:gap-3">
          {backHref && (
            <IconButton
              icon={ArrowLeft}
              variant="slate"
              size="md"
              href={backHref}
            />
          )}
          {icon}
          <h1 className="text-xl font-medium text-foreground">{title}</h1>
          {badges}
        </div>

        {/* Actions */}
        {actions && (
          <div className="flex flex-wrap gap-2">
            {actions}
          </div>
        )}
      </div>

      {/* Details row */}
      {details && (
        <div className="space-y-2 text-sm text-muted-foreground">
          {details}
        </div>
      )}
    </div>
  );
};
